import Summary from '../views/Release/Summary'

let routes = {
    path: '/releases/summary',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '',
            name: 'releases-summary',
            component: Summary,
        },
    ],
}

export default routes
